//  ######  #####      ###     ####  #####
//    ##    ##  ##    ## ##   ##     ##
//    ##    #####    ##   ##  ##     #####
//    ##    ##  ##   #######  ##     ##
//    ##    ##   ##  ##   ##   ####  #####
/*
  js-clone-item--をjs-clone-frame--に複製する
  */
if (document.getElementsByClassName('js-trace')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-trace')) {
      return
    }

    const frameTarget = e.target.dataset.traceFrame
    const itemTarget = e.target.dataset.traceItem

    const item = document.getElementsByClassName('js-trace-item--' + itemTarget)[0]
    const frame = document.getElementsByClassName('js-trace-frame--' + frameTarget)[0]

    frame.innerHTML = item.outerHTML
  })
}
